<template>
	<div>
		<!-- logo 时间 -->
		<q-head></q-head>
		
		<div class="page-main about-page">
			
		
			<div  class="read-bd-title fc" style="padding-left: 30px;"><i ></i><h3>医院简介</h3></div>	
			
			<div class="about-box">
				 <div class="fc-bet">
					 <div class="img">
						 <img src="../../assets/300x210.jpg" >
					 </div>
					 <div class="txt">
						 简称某某一附院，始建于1928年9月，集医疗、教学、科研、预防、保健、康复为一体的三级甲等综合医院，先后被评为全国文明单位、全国“百佳医院”、全国卫生计生系统先进集体、全国医院信息化建设先进单位、全国县级医院帮扶示范基地、全国优质护理服务优秀医院、全国医院后勤。<br><br>
						 
						 简称某某一附院，始建于1928年9月，集医疗、教学、科研、预防、保健、康复为一体的三级甲等综合医院，先后被评为全国文明单位、全国“百佳医院”、全国卫生计生系统先进集体、全国医院信息化建设先进单位、全国县级医院帮扶示范基地、全国优质护理服务优秀医院、全国医院后勤。
					 </div>
				 </div>
			</div>
			
			
			<div  class="read-bd-title fc" style="padding-left: 30px;"><i ></i><h3>科室介绍</h3></div>
			
			<div class="about-box">
				 <div class="fc-bet">
					 
					 <div class="txt">
						 简称某某一附院，始建于1928年9月，集医疗、教学、科研、预防、保健、康复为一体的三级甲等综合医院，先后被评为全国文明单位、全国“百佳医院”、全国卫生计生系统先进集体、全国医院信息化建设先进单位、全国县级医院帮扶示范基地、全国优质护理服务优秀医院、全国医院后勤。<br><br>
						 
						 简称某某一附院，始建于1928年9月，集医疗、教学、科研、预防、保健、康复为一体的三级甲等综合医院，先后被评为全国文明单位、全国“百佳医院”、全国卫生计生系统先进集体、全国医院信息化建设先进单位、全国县级医院帮扶示范基地、全国优质护理服务优秀医院、全国医院后勤。
					 </div>
					 <div class="img">
					 						 <img src="../../assets/300x210b.jpg" >
					 </div>
				 </div>
			</div>
			
			<el-carousel :interval="5000" arrow="always" :autoplay="false" :height="height">
			    <el-carousel-item >
					<div class="ks-list">
						<a :class="{on : tabIndex==0}" @click="tabIndex=0">公共卫生科</a>
						<a :class="{on : tabIndex==1}" @click="tabIndex=1">外科</a>
						<a :class="{on : tabIndex==2}" @click="tabIndex=2">内科</a>
						<a :class="{on : tabIndex==3}" @click="tabIndex=3">妇产科</a>
						<a :class="{on : tabIndex==4}" @click="tabIndex=4">公共卫生科</a>
						<a :class="{on : tabIndex==5}" @click="tabIndex=5">外科</a>
						<a :class="{on : tabIndex==6}" @click="tabIndex=6">内科</a>
						<a :class="{on : tabIndex==7}" @click="tabIndex=7">妇产科</a>
					</div>
			    </el-carousel-item>
				<el-carousel-item >
					<div class="ks-list">
						<a :class="{on : tabIndex==10}" @click="tabIndex=10">公共卫生科</a>
						<a :class="{on : tabIndex==11}" @click="tabIndex=11">外科</a>
						<a :class="{on : tabIndex==12}" @click="tabIndex=12">内科</a>
						<a :class="{on : tabIndex==13}" @click="tabIndex=13">妇产科</a>
						<a :class="{on : tabIndex==14}" @click="tabIndex=14">公共卫生科</a>
						<a :class="{on : tabIndex==15}" @click="tabIndex=15">外科</a>
						<a :class="{on : tabIndex==16}" @click="tabIndex=16">内科</a>
						<a :class="{on : tabIndex==17}" @click="tabIndex=17">妇产科</a>
					</div>
				</el-carousel-item>
			</el-carousel>
			
			<div class="ks-doctor-list">
				<ul>
					<li v-for="(item,index) in 7">
						<el-avatar :size="114" :src="circleUrl"></el-avatar>
						<h3>张三</h3>
						<p>专家医师：张三</p>
						<p>专家职称：主任医师</p>
						<p>擅长：中医理疗科</p>
					</li>
				</ul>
			</div>
			
			
			

			
				<div class="list-page fcc">
					<a>上一页</a>
					<span>第</span>
					<span>1/15</span>
					<span>页</span>
					<a>下一页</a>
				</div>
			
			<div class="h92"></div>
			<div class="foot-buttons fc-bet">
				<a href="/" class="btn-home fcc">
					<img src="../../assets/icon/icon-home.png">
					<span>首页</span>
				</a>
				
				<a class="btn-return fcc" @click="returnStep()">
					<img src="../../assets/icon/icon-return.png">
					<span>返回</span>
				</a>
			</div>
		</div>
	</div>
</template>

<script>
	import qHead from '@/components/q-head/q-head.vue';
	
	
	export default {
		components: {
			qHead
			
		},
		data() {
			return {
				height:"260px",
				tabIndex:0,
				circleUrl:require('@/assets/300x210.jpg')
			}
		},
		mounted() {

		},
		methods: {
			changeRadio(i){
				this.radioIndex=i
			}
			
			
		},
		beforeDestroy() {
			//clearInterval(this.timer);
		}

	}
</script>

<style lang="less">
	.page-main{
		overflow-y: auto;
	}
	.about-page{
		.el-carousel{
			width: 100%;
		}
		.el-carousel__item{
			width: 100%;
		}
	}
</style>
